import FACET_CODES from '../constants/facetCodes';
import ActionTypes from '../constants/actionTypes';
import { errorsDefaults } from './defaultStates';
import PRODUCT_CODES from '../constants/productCodes';
import EMAIL_CODES from '../constants/emailCodes';

export default function(state = errorsDefaults, action) {
  switch (action.type) {
    case ActionTypes.FAILED2FETCH[FACET_CODES.MANUFACTURER]:
    case ActionTypes.FAILED2FETCH[FACET_CODES.CHUCK_DETAIL]:
    case ActionTypes.FAILED2FETCH[FACET_CODES.CHUCK_TYPE]:
    case ActionTypes.FAILED2FETCH[FACET_CODES.CHUCK_SIZE]:
    case ActionTypes.FAILED2FETCH[PRODUCT_CODES.PRODUCTS]:
    case ActionTypes.FAILED2FETCH[EMAIL_CODES.PRICING_REQUEST]:
      return {
        error: 'Errors_RequestFailureMsg',
        hasError: true
      };

    case ActionTypes.UPDATE[FACET_CODES.MANUFACTURER]:
    case ActionTypes.UPDATE[FACET_CODES.CHUCK_DETAIL]:
    case ActionTypes.UPDATE[FACET_CODES.CHUCK_TYPE]:
    case ActionTypes.UPDATE[FACET_CODES.CHUCK_SIZE]:
    case ActionTypes.UPDATE[PRODUCT_CODES.PRODUCTS]:
    case ActionTypes.UPDATE[EMAIL_CODES.PRICING_REQUEST]:
      return {
        error: '',
        hasError: false
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_errors.js